/**
 * Created by lycheng on 2017/10/20.
 */
import 'babel-polyfill'
import { checkLogin } from 'js/api/user'
import { showLoginModal } from 'js/libs/utils-login'

/**
 * 将数据千分位
 * @param num
 * @returns {string}
 */
function toThousands (num) {
  num = (num || 0) + ''
  return num.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
}

// 追加script
function appendScript (src) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script')
    script.setAttribute('type', 'text/javascript')
    script.setAttribute('src', src)
    if (script.addEventListener) {
      script.addEventListener('load', resolve)
      document.body.appendChild(script)
    } else {
      // ie
      script.attachEvent('readystatechange', resolve)
      $('body').append(script)
    }
  })
}

/**
 * 追加iframe
 * @param src
 * @returns {Promise}
 */
function appendIframe (src) {
  return new Promise(function (resolve, reject) {
    var iframe = document.createElement('iframe')
    iframe.setAttribute('src', src)
    $(iframe).css({
      position: 'absolute',
      zIndex: -1000,
      overflow: 'hidden',
      width: '0',
      height: '0',
      opacity: 0
    })
    if (iframe.addEventListener) {
      iframe.addEventListener('load', resolve)
      document.body.appendChild(iframe)
    } else {
      // ie
      iframe.attachEvent('readystatechange', resolve)
      $('body').append(iframe)
    }
  })
}

// 判断是否是支持的浏览器
function checkSupport () {
  var flag = true
  var appName = navigator.appName
  var appVersion = navigator.appVersion.split(';')
  if (appVersion.length > 1) {
    appVersion = appVersion[1].replace(/[ ]/g, '')
    if (appName === 'Microsoft Internet Explorer' &&
      (appVersion === 'MSIE6.0' ||
      appVersion === 'MSIE7.0' ||
      appVersion === 'MSIE8.0' ||
      appVersion === 'MSIE9.0')) {
      flag = false
    }
  }

  return flag
}

/**
 * 获得地址栏中指定参数名称的参数值
 */
function getQueryString (name, search) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  search = search || window.location.search
  var r = search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

/**
 * 设置地址栏中指定参数名称的参数值
 */
function setQueryString (key, value, url) {
  url = url || window.location.href
  // 老的逻辑：设置参数时只能一个一个的设置
  if (typeof key === 'string') {
    let reg = new RegExp(key + '=\\w*', 'g')
    let keyValue = key + '=' + value
    if (url.indexOf('?') > -1) {
      if (url.indexOf(key) > -1) {
        url = url.replace(reg, keyValue)
      } else {
        url += '&' + keyValue
      }
    } else {
      url += '?' + keyValue
    }
  } else {
    // 新的逻辑：可以通过json的key-value方式同时设置多个
    let queryObj = key
    let urlArr = url.split('?')
    let searchArr = []
    let searchItem
    let searchObj = {}
    let queryStr = ''
    if (urlArr.length > 1) {
      searchArr = urlArr[1].split('&')
    }
    for (let i = 0; i < searchArr.length; i++) {
      try {
        searchItem = searchArr[i].split('=')
        searchObj[searchItem[0]] = searchItem[1]
      } catch (e) { }
    }
    for (let p in queryObj) {
      searchObj[p] = queryObj[p]
    }
    for (let p in searchObj) {
      if (searchObj[p]) {
        queryStr += `&${p}=${searchObj[p]}`
      }
    }
    queryStr = queryStr.replace('&', '?')
    url = urlArr[0] + queryStr
  }

  return url
}

/**
 * 登陆情况下跳转到给定地址
 * @param url
 * @param target
 */
function toUrl (url, target) {
  target = target || '_self'
  window.open(url, target)
  // checkLogin().then(function (result) {
  //   if (result.data) {
  //     window.open(url, target)
  //   } else {
  //     showLoginModal()
  //   }
  // })
}

function isWorkday (date) {
  const _date = !date ? new Date() : new Date(date)
  const getday = _date.getDay()
  if (getday === 6 || getday === 0) {
    return false
  }
  return true
}

// 9:30-17:30
function isWorkTime () {
  const date = new Date()
  const hour = date.getHours()
  const minite = date.getMinutes()
  const nowDate = hour * 60 + minite
  if (nowDate >= 570 && nowDate <= 1050) {
    return true
  }
  return false
}

export {
  toUrl,
  toThousands,
  appendScript,
  appendIframe,
  checkSupport,
  getQueryString,
  setQueryString,
  isWorkday,
  isWorkTime
}



// WEBPACK FOOTER //
// ./src/js/libs/utils.js